import axiosInstance from '../../api/axiosInstance';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Users, UserPlus, Pencil, Trash2, Phone,
  ShieldCheck, Gamepad2, Trophy, Clock, Link as LinkIcon
} from 'lucide-react';

function Home() {
  const [ownerInfo, setOwnerInfo] = useState({ name: '', phoneNo: '', website: 'A1 Satta King' });
  const [owners, setOwners] = useState([]);
  const [games, setGames] = useState([]);
  const [todayResults, setTodayResults] = useState([]);
  const [submit, setSubmit] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
    getStats();
  }, []);

  const getStats = async () => {
    try {
      const [gamesRes, resultsRes] = await Promise.all([
        axiosInstance.get('/getgames'),
        axiosInstance.get('/getgameresults', {
          params: { date: new Date().toISOString().split('T')[0] }
        }),
      ]);
      if (gamesRes.data)   setGames(gamesRes.data);
      if (resultsRes.data) setTodayResults(resultsRes.data);
    } catch { /* silent */ }
  };

  const getData = async () => {
    try {
      const result = await axiosInstance.get('/getowners');
      if (result?.data) setOwners(result.data);
      else setOwners([]);
    } catch (error) {
      toast.error('Error fetching owners');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axiosInstance.post('/addowner', ownerInfo);
      toast.success('Owner added successfully');
      getData();
      setOwnerInfo({ name: '', phoneNo: '', website: 'A1 Satta King' });
    } catch { toast.error('Error adding owner'); }
    finally { setLoading(false); }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOwnerInfo(prev => ({ ...prev, [name]: value }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this owner?')) return;
    try {
      await axiosInstance.delete('/deleteowner', { data: { id } });
      toast.success('Owner deleted');
      getData();
    } catch { toast.error('Error deleting owner'); }
  };

  const handleUpdate = (idx) => {
    setSubmit(false);
    setOwnerInfo(owners[idx]);
  };

  const submitUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axiosInstance.put('/updateowner', ownerInfo);
      toast.success('Owner updated');
      getData();
      setOwnerInfo({ name: '', phoneNo: '', website: 'A1 Satta King' });
      setSubmit(true);
    } catch { toast.error('Error updating owner'); }
    finally { setLoading(false); }
  };

  const pendingResults = games.length - todayResults.length;

  return (
    <>
      {/* â”€â”€ Page Header â”€â”€ */}
        <div className="page-header">
          <h2>Dashboard</h2>
          <p>Welcome back, Admin. Here's what's happening today.</p>
        </div>

        {/* â”€â”€ Stats Cards â”€â”€ */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon purple"><Gamepad2 /></div>
            <div className="stat-info">
              <div className="stat-value">{games.length}</div>
              <div className="stat-label">Total Games</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon green"><Trophy /></div>
            <div className="stat-info">
              <div className="stat-value">{todayResults.length}</div>
              <div className="stat-label">Results Today</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon orange"><Clock /></div>
            <div className="stat-info">
              <div className="stat-value">{pendingResults < 0 ? 0 : pendingResults}</div>
              <div className="stat-label">Pending Results</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon blue"><Users /></div>
            <div className="stat-info">
              <div className="stat-value">{owners.length}</div>
              <div className="stat-label">Total Owners</div>
            </div>
          </div>
        </div>

        {/* â”€â”€ Owner Management â”€â”€ */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">
              <UserPlus size={16} />
              {submit ? 'Add New Owner' : 'Update Owner'}
            </div>
            {!submit && (
              <button className="btn btn-ghost btn-sm" onClick={() => { setSubmit(true); setOwnerInfo({ name: '', phoneNo: '', website: 'A1 Satta King' }); }}>
                Cancel
              </button>
            )}
          </div>
          <div className="card-body">
            <form onSubmit={submit ? handleSubmit : submitUpdate}>
              <div className="form-grid form-grid-cols-3" style={{ maxWidth: 800 }}>
                <div className="form-group">
                  <label className="form-label">Owner Name</label>
                  <input
                    name="name"
                    value={ownerInfo.name}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="e.g. Rajan Sharma"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input
                    name="phoneNo"
                    type="number"
                    value={ownerInfo.phoneNo}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="e.g. 9876543210"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Website Routing</label>
                  <select name="website" value={ownerInfo.website || 'A1 Satta King'} onChange={handleChange} className="form-input" required>
                    <option value="A1 Satta King">A1 Satta King</option>
                    <option value="Satta Bazar">Satta Bazar</option>
                    <option value="Both">Both Websites</option>
                  </select>
                </div>
              </div>
              <div style={{ marginTop: 16 }}>
                <button type="submit" className={`btn ${submit ? 'btn-primary' : 'btn-success'}`} disabled={loading}>
                  {submit ? <UserPlus size={15} /> : <ShieldCheck size={15} />}
                  {loading ? 'Saving...' : submit ? 'Add Owner' : 'Update Owner'}
                </button>
              </div>
            </form>
          </div>

          {/* Owners Table */}
          <div className="table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Owner Name</th>
                  <th><Phone size={12} style={{display:'inline',marginRight:4}}/>Phone</th>
                  <th>Target Website</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {owners.length === 0 ? (
                  <tr><td colSpan="5" style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '32px 0' }}>No owners added yet</td></tr>
                ) : (
                  owners.map((item, idx) => (
                    <tr key={item._id}>
                      <td style={{ color: 'var(--text-muted)', width: 40 }}>{idx + 1}</td>
                      <td style={{ fontWeight: 600 }}>{item.name}</td>
                      <td><span className="badge badge-blue">{item.phoneNo}</span></td>
                      <td>
                        <span className={`badge ${!item.website || item.website === 'Both' ? 'badge-blue' : item.website === 'A1 Satta King' ? 'badge-success' : 'badge-warning'}`}>
                          <LinkIcon size={12} style={{ marginRight: 4, display: 'inline' }} />
                          {item.website || 'Both'}
                        </span>
                      </td>
                      <td>
                        <div className="action-cell">
                          <button className="btn btn-warning btn-sm" onClick={() => handleUpdate(idx)}>
                            <Pencil size={13} /> Edit
                          </button>
                          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item._id)}>
                            <Trash2 size={13} /> Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
    </>
  );
}

export default Home;
